import * as React from "react";
import { LS_LEO_DOCK_HIDDEN } from "@/zapi-frontend/shared/local-storage/keys";

const listeners = new Set<() => void>();
// Used when storage is unavailable, so the choice still lasts until the page reloads.
let hiddenInMemory = false;

function subscribe(onChange: () => void) {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}

function readHidden() {
  try {
    return window.localStorage.getItem(LS_LEO_DOCK_HIDDEN) === "true";
  } catch {
    return hiddenInMemory;
  }
}

function useLeoDockOpen(): [boolean, (open: boolean) => void] {
  const hidden = React.useSyncExternalStore(subscribe, readHidden, () => false);
  const setOpen = React.useCallback((open: boolean) => {
    hiddenInMemory = !open;
    try {
      window.localStorage.setItem(LS_LEO_DOCK_HIDDEN, String(!open));
    } catch {
      // hiddenInMemory keeps it.
    }
    listeners.forEach((listener) => listener());
  }, []);
  return [!hidden, setOpen];
}

export { LS_LEO_DOCK_HIDDEN as LEO_LS_LEO_DOCK_HIDDEN, useLeoDockOpen };
